import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import { PopupStates } from '../Enums';

// Popup imports
class Publish extends React.Component {
    getStateContent(state) {
        switch(state) {
            case PopupStates.ERROR: {
                return this.renderError();
            }
            default: {
                return (
                    <div>
                        <h1>Er gaat iets fout!</h1>
                        <p>De status ({state}) van deze popup is niet ondersteund!</p>
                    </div>
                );
            }
        }
    }

    renderError = () => {
        const { popup } = this.props;
        const { response } = popup.properties;

        return (
            <>
                <div>
                    <h1>
                        Publiceren is niet gelukt
                    </h1>
                    <p>
                        Probeer het later opnieuw.
                    </p>
                </div>
                <span className="error-details">{response}</span>
            </>
        );
    }

    render = () => {
        const { popup } = this.props;
        const { state } = popup;

        const content = this.getStateContent(state);

        return content;
    }
}

const mapStateToProps = state => ({
    popup: state.popup
});

export default connect(
    mapStateToProps
)(Publish);